import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_URL } from '../consts';
import {
  IGetDynamicElementsRequest,
  IGetDynamicElementsResponse,
  IGetStaticElementsResponse,
} from '../types';

export const currentPageElementsAPI = createApi({
  reducerPath: 'currentPageElementsAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL + '/api/v2',
    prepareHeaders(headers, { getState }) {
      const token = undefined;

      if (token) {
        headers.set('authorization', `Bearer ${token}`);
        return headers;
      }
    },
  }),
  endpoints: (build) => ({
    getDynamicElements: build.query<IGetDynamicElementsResponse, IGetDynamicElementsRequest>({
      query: ({ link, token }) => {
        const params: IGetDynamicElementsRequest = { link };

        if (token) {
          params.token = token;
        }

        return {
          url: '/client/pages',
          method: 'get',
          params,
        };
      },
    }),

    getStaticElements: build.query<IGetStaticElementsResponse, unknown>({
      query: () => ({
        url: '/client/pages/static-elements',
        method: 'get',
      }),
    }),
  }),
});

export const {
  useGetStaticElementsQuery,
  useLazyGetStaticElementsQuery,
  useGetDynamicElementsQuery,
  useLazyGetDynamicElementsQuery,
} = currentPageElementsAPI;

export const { getStaticElements, getDynamicElements } = currentPageElementsAPI.endpoints;
